/**
 * Created by mykurisu on 2017/12/6.
 */
import React from 'react'
import axios from 'axios'
import qs from 'qs'
import {Toast, Mask} from 'react-weui'
import {connect} from 'react-redux'
import { Link, browserHistory } from 'react-router'
import {renderMoney, isLZWKAPP, TimeStream, randomArr} from '../../../utils'
import { WKOwnDialog } from '../../../components/wk'
import {avatar_list} from '../../../utils/avatar_list'
import Item from './CouponItem'
import AnimationItem from './AnimationItem'

import '../../../css/page/CouponSPA.css'
import ShareIcon from '../../../images/activity/couponspa/share_icon.png'
import headerLuckImg from '../../../images/activity/couponspa/header-luck.png'
import allFlyImg from '../../../images/activity/couponspa/all-fly.png'
import clickToLuckImg from '../../../images/activity/couponspa/click-to-luck-btn.png'
import redpacketImg from '../../../images/activity/couponspa/redpacket.png'
import couponBgImg from '../../../images/activity/couponspa/coupon-bg.png'
import richerImg from '../../../images/activity/couponspa/richer.png'
import wishCardBgImg from '../../../images/activity/couponspa/wish-card-bg.png'
import wishCardEntryImg from '../../../images/activity/couponspa/wish-card-entry.png'
import spaBannerImg from '../../../images/activity/couponspa/spa-banner.png'
import spaBannerText from '../../../images/activity/appInvite/spa-header-text.png'
import spaBannerBg from '../../../images/activity/appInvite/spa-header-bg.png'

// 测试用的inviter_id
// const inviters = ['36266813', '36266814', '36266815', '36266816', '36266817', '36266818', '36266819']
const inviters = ['44814268', '44006949', '44814193', '44318813', '44814310', '44814368', '44814415', '44814460', '45269110', '46717336', '44814415', '44814460']



class CouponSPA extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            beginShowTime: false,
            channels: [],
            isInit: false,
            is_join: false,
            originIsJoin: false,

            remainder_number: 0,
            used_channels: [],
            end_time: '',
            isPending: false,
            coupon_number: 0,
            price: 0,
            redpacketsPos: this.redpacketsPos,
            isZoomIn: false,
            isRedpacketExchanging: true,
            isFirstJoin: false,
            isPopRedpacketDialog: +props.location.query.pop_card === 1,
            
            wishCardAvatar: '',
            wishCardImg: '',
            wishCardText: '',

            //fake_content
            animation_content: '',
            isShowToAppDialog: false,
        }
    }

    componentDidMount() {
        this.mta('app_invite_download_app_page')
        let img = new Image(0, 0);
        img.src = headerLuckImg;
        new Image(0, 0).src = spaBannerImg;
        const bagid = this.props.location.query.bagid
        if (!bagid) {
            return location.assign('/')
        }
        if (+this.props.location.query.pop_card === 1) {
            // this.mta('couponspa_wish_card_show')
        } 
        this.fetchInfo(bagid)
    }

    componentWillUnmount () {
        this.fake_animation && clearInterval(this.fake_animation);
    }

    mta (payload) {
        this.props.dispatch({ type: 'MTA_CLICK', payload });
    }

    fetchInfo (bagid) {
        const query = this.props.location.query
        const params = +query.pop_card === 1 ? {
            pop_card: query.pop_card,
            bag_inviter_id: query.bag_inviter_id,
            template_id: query.template_id,
            greettext: query.greettext,
        } : {}
        axios.get(`/api/coupon/weike_active/${bagid}/info`, {
            params: params
        })
            .then(res => {
                const resData = res.data.data
                const originIsJoin = resData.is_join
                if (+query.pop_card === 1) {
                    resData.is_join = false
                }
                if (!resData.is_join) {
                    // this.mta('couponspa_random_rp_show')
                }
                if (res.data.code === 0) {
                    // 过期就闪人
                    if (resData.status === 'deadline') {
                        return location.assign('/')
                    }
                    if (+query.is_auto_receive === 1) {
                        this.fetchGetCoupon(bagid)
                    }
                    // this.mta(`new_coupon_spa_enter_${bagid}`)
                    document.title = resData.title;
                    if (!resData.is_join && !this.props.location.query.get_coupon){
                        // this.mta(`new_coupon_spa_btnshow_${bagid}`)
                    }
                    if (+query.pop_card !== 1) {
                        // setTimeout(() => {
                        //     this.randomRedpackets()
                        // }, 300)
                    }
                    this.setState({
                        remainder_number: resData.remainder_number,
                        used_channels: resData.used_channels,
                        is_join: resData.is_join,
                        originIsJoin: originIsJoin,
                        end_time: resData.end_time,
                        channels: resData.channels,
                        coupon_number: resData.coupon_number,
                        price: resData.price,
                        isInit: true,
                        wishCardAvatar: resData.inviter_info && resData.inviter_info.account.small_avatar_url,
                        wishCardImg: resData.inviter_info && resData.inviter_info.theme.avatar,
                        wishCardText: resData.inviter_info && resData.inviter_info.greettext,
                    });
                    this.handleFaker()
                    this.initShareData(resData, bagid)
                }else {
                    location.assign('/')
                }
            });
    }
    getInviterId () {
        let from
        const wkFrom = this.props.location.query.wk_from
        from = wkFrom ? wkFrom : this.props.location.query.from
        const queryInviterId = this.props.location.query.inviter_id
        if (queryInviterId) return queryInviterId
        switch (from) {
            case 'back_subscribed':
                return inviters[0]
            case 'back_no_subscribed':
                return inviters[1]
            case 'article':
                return inviters[2]
            case 'app':
            case 'app_invite':
                return inviters[3]
            case 'wx_share':
                return inviters[4]
            case 'home':
                return inviters[5]
            case 'schedule':
                return inviters[6]
            case 'card_sharelink':
                return inviters[7]
            case 'sharecard':
                return inviters[8]
            case 'index_gap':
                return inviters[10]
            case 'mywk_gap':
                return inviters[11]
            default:
                return inviters[9]
        }
    }
    initShareData (data, bagid) {
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: data.share_info.share_title,
                desc: data.share_info.share_description,
                imgUrl: data.share_info.share_icon,
                type: 'link',
                link: data.share_info.share_url,
                is_resell: '1'
            }
        });
    }
    fetchGetCoupon (bagid) {
        const inviterId = this.getInviterId()
        const {query} = this.props.location;
        let data = new FormData();
        data.append('bag_inviter_id', query.bag_inviter_id || 0);
        axios.post(`/api/coupon/weike_active/${bagid}/receive_coupons/${inviterId}`, data)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        is_join: true,
                        isFirstJoin: true,
                    })
                    this.handleFaker()
                } else {
                    // location.assign('/')
                }
            })
            .catch(err => alert('系统繁忙，请稍后再试'))
    }

    handleGetCoupon(bagid) {
        this.fetchGetCoupon(bagid)
        // this.mta(`new_coupon_spa_btnclick_${bagid}`)
    }

    handleFaker() {
        if (this.fake_animation) {
            return
        }
        let raw_list = avatar_list;
        let result = [];

        let avatar_num = 10;

        for (let i = 0;i < avatar_num;i++){
            let random = Math.floor(Math.random() * (raw_list.length - i));
            result.push(raw_list[random]);
            raw_list[random] = raw_list[raw_list.length - i - 1];
        }

        let list = [
            {img: result[0], time: '3'},
            {img: result[1], time: '4'},
            {img: result[2], time: '5'},
            {img: result[3], time: '6'},
            {img: result[4], time: '6'},
            {img: result[5], time: '7'},
            {img: result[6], time: '8'},
            {img: result[7], time: '8'},
            {img: result[8], time: '9'},
            {img: result[9], time: '9'}
        ];

        let index = -1;

        this.setState({
            animation_content: list[0]
        }, () => {
            index = 0
        });

        this.fake_animation = setInterval(() => {
            if (index === 9){
                index = 0
            }else {
                index = index + 1
            }
            this.setState({
                animation_content: list[index]
            })
        }, 2300)
    }

    // randomRedpackets () {
    //     let clock = 0
    //     this.timer = setInterval(() => {
    //         this.setState({ redpacketsPos: randomArr(this.state.redpacketsPos) })
    //         clock ++
    //         if (clock > 2) {
    //             clearInterval(this.timer)
    //             this.setState({ isRedpacketExchanging: false })
    //         }
    //     }, 600)
    // }

    // onClickRedpacket (index, bagid) {
    //     if (this.state.isRedpacketExchanging) {
    //         return
    //     }
    //     this.mta('couponspa_click_random_rp')
    //     // 一张放大其他消失
    //     this.state.redpacketsPos.forEach((item, i) => {
    //         if (i === index) {
    //             this.state.redpacketsPos[index] = this.zoomStyle
    //         } else {
    //             this.state.redpacketsPos[i] = { ...this.state.redpacketsPos[i], opacity: 0 }
    //         }
    //     })
    //     this.setState({ redpacketsPos: this.state.redpacketsPos, isZoomIn: true })
    //     // 一张旋转
    //     setTimeout(() => {
    //         this.state.redpacketsPos[index] = { ...this.state.redpacketsPos[index], animation: 'activity-coupon-redpacket-flip 1.5s linear 0s infinite' }
    //         this.setState({ redpacketsPos: this.state.redpacketsPos })
    //     }, 500)
    //     setTimeout(() => {
    //         if (this.state.originIsJoin) {
    //             this.setState({ is_join: true })
    //         } else {
    //             this.fetchGetCoupon(bagid)
    //         }
    //         const path = this.props.location.pathname + this.props.location.search
    //         if (path.indexOf('pop_card=1') > -1) {
    //             browserHistory.replace(path.replace('pop_card=1', 'pop_card=0')) 
    //         }
    //     }, 1300)
    // }

    onClickWishCard (e) {
        // this.mta('couponspa_click_wish_card')
        this.setState({ isPopRedpacketDialog: false, isRedpacketExchanging: false }, () => {
            this.onClickRedpacket(1, this.props.location.query.bagid)
        })
    }

    showToAppDialog () {
        this.mta('app_invite_click_channel')
        this.setState({ isShowToAppDialog: true })
    }

    toApp (isFromDialog) {
        this.mta('app_invite_download_app')
        if (isFromDialog) {
            this.mta('app_invite_click_channel_click_toapp')
        }
        this.setState({ isPending: true, isShowToAppDialog: false })
        axios.post(`/api/marketing/app_invitation/accept`, qs.stringify({
            invite_code: this.props.location.query.invite_code || 0,
        }))
            .then(res => {
                const data = res.data.data
                this.setState({ isPending: false })
                if (res.data.code <= 0) {
                    if (res.data.code === -1) alert(res.data.msg)
                    location.assign('https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike')
                } else {
                    alert(res.data.msg)
                }
            })
    }

    render() {
        const {
            channels, used_channels, end_time, is_join, isFirstJoin, isPopRedpacketDialog,
            remainder_number, coupon_number, price, redpacketsPos, isInit, wishCardAvatar,
        } = this.state
        const bagid = this.props.location.query.bagid
        const isAutoReceive = +this.props.location.query.is_auto_receive === 1
        const inviterId = this.getInviterId()

        if (!isInit) {
            return (
                <div className="wk-page couponspa-no-init">
                    <Toast show={true} icon={'loading'} />
                </div>
            )
        }

        // 优惠券页
        return (
            <div className="activity__couponspa-app" style={{paddingBottom: '20px'}}>
                <AnimationItem content={this.state.animation_content}/>

                <Toast show={this.state.isPending} icon={'loading'} />

                {/* 当有券的时候显示 */}
                <div className={`has-coupon-wrap ${remainder_number > 0 ? '' : 'hide'}`}>
                    <div className="header" ref={r => this.header = r} style={{paddingTop: '0', backgroundImage: `url(${spaBannerBg})`}}>
                        <div className="spa-banner" style={{padding: '0'}}>
                            <img src={spaBannerText} alt=""/>
                        </div>
                    </div>

                    <div className="coupon" style={{backgroundImage: `url(${couponBgImg})`}}>
                        <div className="money">
                            <span>￥</span>
                            <span className="big">{+price}</span>
                        </div>
                        <div className="title">
                            <span>无门槛现金券</span>
                            {
                                isFirstJoin && <span>{remainder_number}张</span>
                            }
                        </div>
                        <div className="time">有效期至：{end_time && TimeStream(end_time, 'YMD')}</div>
                    </div>
                    
                    <div className="coupon-num-alert">
                        {
                            isFirstJoin && <div className="title">恭喜你！获得{(price * coupon_number).toFixed()}元微课大礼包</div>
                        }
                        {
                            !isFirstJoin && remainder_number > 0 && (
                                <div className="title">你有{(price * remainder_number).toFixed()}元大礼包未使用</div>
                            )
                        }
                        <div className="intro">（内含{+price}元现金券{remainder_number}张）</div>
                    </div>
                </div>
                
                {/* 当券用完的时候显示 */}
                <div className={`no-coupon-wrap ${remainder_number === 0 ? '' : 'hide'}`}>
                    <img src={richerImg} alt=""/>
                    <div className="text">
                        <p>土豪，你领取的优惠券已全部使用</p>
                        <p>微课妹妹正快马加鞭筹备下期活动</p>
                    </div>
                </div>

                <div className="to-app-btn" onClick={e => this.toApp()}>
                    前往APP购买（限时使用）
                </div>
                
                <div className="couponspa__showTime">
                    {/* 已领取 */}
                    {
                        is_join && remainder_number !== 0 && (
                            <div className="couponspa__intro">
                                <p>*可用于购买本页面内任意专栏，每次限用一张</p>
                                <p>*本活动页优惠专栏不定期更新，看上了请及时购买</p>
                            </div>
                        )
                    }

                    <div className="coupons-wrap">
                        <div className="couponspa__list">
                            {
                                channels.map(item => {
                                    if (used_channels.indexOf(item.id) < 0) {
                                        return (
                                            <Item
                                                key={item.id}
                                                content={item}
                                                dispatch={this.props.dispatch}
                                                is_join={is_join}
                                                inviterId={inviterId}
                                                price={price}
                                                isAppInvite={true}
                                                showToAppDialog={() => this.showToAppDialog()}
                                            />
                                        )
                                    }
                                })
                            }
                        </div>
                            
                        {
                            used_channels.length > 0 && (
                                <div className="more" style={{paddingTop: remainder_number === 0 ? '0' : '15px'}}>
                                    <Link to='/account/bought'>{'>> 查看购买记录 <<'}</Link>
                                </div>
                            )
                        }
                    </div>
                </div>
                
                <WKOwnDialog type="ios" title='' buttons={[
                    { label: '取消', type: 'default', onClick: () => this.setState({ isShowToAppDialog: false }) },
                    { label: '立即前往', onClick: () => this.toApp(true) }
                ]} show={this.state.isShowToAppDialog}>
                    请前往APP购买，享受最低折扣（限时使用）
                </WKOwnDialog>
                
            </div>
        )
    }
}


export default connect((state) => ({}))(CouponSPA)



// WEBPACK FOOTER //
// ./src/pages/ActivityPage/Coupon/CouponSPAApp.js